import * as entityTypes from 'core/constants/report-type';
import { AutoCompleteChipsProps } from '@placer-ui/components';
import { noop } from 'lodash';

export const DEFAULT_ENTITY_SECTION = entityTypes.ENTITY_SECTION_PROPERTY;

export const SUGGESTIONS_TYPES_CHIPS = [
    {
        value: entityTypes.ENTITY_SECTION_PROPERTY,
        categoryText: 'Properties',
    },
    {
        value: entityTypes.ENTITY_SECTION_CHAIN,
        categoryText: 'Chains',
    },

    {
        value: entityTypes.ENTITY_SECTION_MARKET,
        categoryText: 'Markets',
    },
    {
        value: entityTypes.ENTITY_SECTION_BILLBOARD,
        categoryText: 'Traffic Pins',
    },
];

export const DEFAULT_TAB_CHIPS_CONFIG: AutoCompleteChipsProps = {
    chips: SUGGESTIONS_TYPES_CHIPS.map((chipItem) => ({
        ...chipItem,
        isSelected: chipItem.value === DEFAULT_ENTITY_SECTION,
    })),
    onChipClick: noop,
};
